/*=====================================
    CupoyNoteHtmlParser

    以下「只能」由外部決定事件
    1. tag點擊事件: event name is hashtagOnClick

    以下「可以」由外部決定事件 @see constructor options
    1. 圖片點擊事件: event name is playImageBlock
    2. 相簿點擊事件: event name is playAlbumBlock

    Author: Gray
    CreateTime: 2019 / 03 / 08
=====================================*/

class CupoyNoteHtmlParser {
    
    // ------------------------------
    // constructor
    // ------------------------------
    constructor(html, options) {

        if(!document) {
            console.warn('no document');
            return;
        }

        if(!options) {
            options = {};
        }

        this.rootid = 'cupoynote-' + this._generateUid();

        this.element = document.createElement('div');
        this.element.id = this.rootid;
        this.element.innerHTML = html;
        
        this.options = {
            defaultFontSize: options.defaultFontSize || 16,
            defaultLineHeight: options.defaultLineHeight || 1.6,
            defaultFontColor: options.defaultFontColor || '#333',
            handlePlayImageBlock: options.handlePlayImageBlock || false,
            handlePlayAlbumBlock: options.handlePlayAlbumBlock || false,
        }

        this._convertToCupoyPreviewHtml();
    }

    // ------------------------------
    // _generateUid
    // ------------------------------
    _generateUid() {

        var time = Date.now();
        var ran = Math.floor(Math.random() * 10000);
        var uid = String(time) + ran;

        return uid;
    }

    // ------------------------------
    // 把空白以及換行去掉，減少文字size
    // ------------------------------
    _zipcodeText(text) {

        return text.replace(/[\s]{2,}/g, " ");
    }

    // ------------------------------
    // _getStyleText
    // ------------------------------
    _getStyleText() {

        let defaultFontSize = this.options.defaultFontSize;
        let defaultLineHeight = this.options.defaultLineHeight;
        let defaultFontColor = this.options.defaultFontColor;

        let style = `
            <style type="text/css">
                #${this.rootid} {
                    line-height: ${defaultLineHeight};
                    color: ${defaultFontColor};
                    font-size: ${defaultFontSize}px;
                }

                #${this.rootid} a {
                    color: ${defaultFontColor};
                }

                #${this.rootid} h1, #${this.rootid} h2, #${this.rootid} h3, #${this.rootid} h4, #${this.rootid} h5, #${this.rootid} h6 {
                    line-height: ${defaultLineHeight};
                }
            </style>
        `;

        return style;
    }

    // ------------------------------
    // getTextblockClickText
    // ------------------------------
    getTextblockClickText(attachurl, uuid) {

        let onclick = `
            event.preventDefault();
            event.stopImmediatePropagation();
        `;

        if(attachurl && attachurl !== 'undefined') {
            if(attachurl.indexOf("blob:") === 0) {
                onclick += `
                    let promise = new Promise(function(resolve, reject) {
                        fetch("${attachurl}").then(function(response) {
                            response.json().then(function(result) {
                                if(!result || result.error) {
                                    reject(result && result.error);
                                } else {
                                    resolve(result);
                                }
                            }, function(error) {
                                reject(error);
                            });
                        }).catch(function(error) {
                            reject(error);
                        });
                    });
                `;
            } else  {
                attachurl = attachurl.replace('http://', "//");
                attachurl = attachurl.replace('https://', "//");

                onclick += `
                    let promise = new Promise(function(resolve, reject) {
                        fetch("${attachurl}", {
                            method: 'GET',
                            mode: 'cors'
                        }).then(function(response) {
                            response.json().then(function(result) {
                                if (!result || result.error) {
                                    reject(result && result.error);
                                } else {
                                    resolve(result);
                                }
                            }, function(error) {
                                reject(error);
                            });
                        }).catch(function(error) {
                            reject(error);
                        });
                    });
                `;
            }

            let defaultExpandTextBlock = this._getDefaultExpandTextBlock(uuid);
            let closeTextBlockClickText = `
                let article = document.querySelector('article[uuid="${uuid}"]');
                let oridate = article.getElementsByClassName('textblock-ori-data');

                if(oridate && oridate.length === 1) {
                    article.insertAdjacentHTML('afterend', oridate[0].innerHTML);
                    article.parentNode.removeChild(article);
                }
            `;

            onclick += `
                let self = this;
                promise.then(function(result) {
                    
                    let ele = document.createElement('div');

                    ele.innerHTML = ${'`' + defaultExpandTextBlock + '`'};

                    let article = ele.getElementsByTagName('article');

                    if(article && article.length === 1) {
                        let _article = article[0];

                        let title = _article.getElementsByTagName('h4');
                        
                        if(title && title.length === 1) {
                            title[0].innerText = result.title;
                        }

                        let content = _article.getElementsByTagName('span');
                        
                        if(content && content.length === 1) {
                            content[0].innerHTML = result.html;
                        }

                        let button = _article.getElementsByClassName('textblock-close-btn');

                        if(button && button.length === 2) {
                            button[0].setAttribute('onclick', ${'`' + closeTextBlockClickText + '`'});
                            button[1].setAttribute('onclick', ${'`' + closeTextBlockClickText + '`'});
                        }

                        let oridate = _article.getElementsByClassName('textblock-ori-data');

                        if(oridate && oridate.length === 1) {
                            oridate[0].innerHTML = self.outerHTML;
                        }
                    }
                    
                    self.insertAdjacentHTML('afterend', ele.innerHTML);
                    self.parentNode.removeChild(self);
                });
            `;
        }

        return this._zipcodeText(onclick);
    }

    // ------------------------------
    // _getDefaultExpandTextBlock
    // ------------------------------
    _getDefaultExpandTextBlock(uuid) {

        let articleStyle = `
            position: relative;
            margin: 30px 0;
            padding: 40px 30px;
            border: 1px solid #CCCCCC;
        `;

        let titleStyle = `
            line-height: 42px;
            margin: 0 0 10px 0;
            color: #565151;
            font-size: 28px;
            font-weight: 600;
        `;

        let foldStyle = `
            position: absolute;
            left: 50%;
            padding: 0 20px;
            border: 1px solid #CCCCCC;
            border-radius: 100px;
            background-color: #FFFFFF;
            font-size: 14px;
            color: #565151;
            transform: translateX(-50%);
            cursor: pointer;
        `;

        let topFoldStyle = `
            top: -16px;
            ${foldStyle}
        `;

        let bottomFoldStyle = `
            bottom: -16px;
            ${foldStyle}
        `;

        let defaultExpandTextBlock = `
            <article uuid="${uuid}" style="${articleStyle}">
                <h4 style="${titleStyle}"></h4>
                <span></span>
                <div style="${topFoldStyle}" class="textblock-close-btn">
                    收起文章
                </div>
                <div style="${bottomFoldStyle}" class="textblock-close-btn">
                    收起文章
                </div>
                <div style="display: none;" class="textblock-ori-data"></div>
            </article>
        `;

        return defaultExpandTextBlock;
    }

    // ------------------------------
    // _getHashtagClickText
    // ------------------------------
    _getHashtagClickText(hashtag, uuid) {
        
        let onclick = `
            this.dispatchEvent(new CustomEvent('hashtagOnClick', {
                bubbles: true,
                cancelable: true,
                detail: {
                    hashtag: '${hashtag}',
                    uuid: '${uuid}'
                }
            }))
        `;

        return this._zipcodeText(onclick);
    }

    // ------------------------------
    // _getAnnotationDivHTML
    // ------------------------------
    _getAnnotationDivHTML(annotation, uuid) {

        let annotationStyle = `
            display: none;
            position: relative;
            width: 100%;
            margin: 4px 0;
            padding: 16px;
            background-color: #F0EFEE;
            color: #6C6666;
            cursor: auto;
            white-space: pre-wrap;
            word-wrap: break-word;
        `;

        let arrowStyle = `
            position: absolute;
            top: -6px;
            left: 0;
            width: 14px;
            height: 14px;
            background-color: #F0EFEE;
            transform: translateX(4px) rotate(45deg);
        `;

        // details
        let expanededAnnotationHTML = `
            <div
                uuid="${uuid}" 
                style="${annotationStyle}" 
                onClick="event.preventDefault();event.stopImmediatePropagation();"
            >
                <div annotation-arrow style="${arrowStyle}"></div>
                ${unescape(annotation)}
            </div>
        `;

        return this._zipcodeText(expanededAnnotationHTML);
    }

    // ------------------------------
    // _getAnnotationClickText
    // ------------------------------
    _getAnnotationClickText(uuid) {

        let onclick = `
            event.preventDefault();
            event.stopImmediatePropagation();

            let annotation = document.querySelector('div[uuid="${uuid}"]');

            if(!annotation) {
                return;
            }

            let isOpen = this.getAttribute('is-annotation-open');

            if(isOpen) {
                annotation.style.display = 'none';
                this.removeAttribute('is-annotation-open')
            } else {
                if(event.srcElement && event.srcElement.offsetLeft) {
                    let arrow = annotation.querySelector('[annotation-arrow]');
                    if(arrow) {
                        arrow.style.left = event.srcElement.offsetLeft + 'px';
                    }
                }
                annotation.style.display = 'inline-block';
                this.setAttribute('is-annotation-open', true);
            }
        `;

        return this._zipcodeText(onclick);
    }

    // ------------------------------
    // _getCopyCodeButtonHtml
    // ------------------------------
    _getCopyCodeButtonHtml(uuid) {

        let preStyleSheet = `
          <style type="text/css">

            .button-${uuid} {
                opacity: 0;
                visibility: hidden;
                display: inline-block;
                position: absolute;
                top: 10px;
                right: 30px;
                height: 30px;
                line-height: 30px;
                padding: 0 16px;
                background-color: #DDD;
                color: #6C6666;
                font-size: 12px;
                cursor: pointer;
                text-align: center;
                user-select: none;
                -webkit-transition: .3s all;
                transition: .3s all;
            }

            .button-${uuid}:hover {
                background-color: #E2DFDE;
            }

            .msg-${uuid} {
                opacity: 0;
                visibility: hidden;
                position: absolute;
                top: 50%;
                left: 50%;
                height: 28px;
                line-height: 28px;
                padding: 0 20px;
                border-radius: 3px;
                background-color: rgba(0, 0, 0, 0.5);
                color: #fff;
                font-size: 12px;
                user-select: none;
                -webkit-transition: .3s all;
                transition: .3s all;
                -webkit-transform: translateX(-50%) translateY(-50%);
                -ms-transform: translateX(-50%) translateY(-50%);
                transform: translateX(-50%) translateY(-50%);
            }
          </style>
        `;

        // details
        let copyCodeButtonHTML = `
            <div>
                <div
                    class="button-${uuid}" 
                >
                    複製程式碼
                </div>
                <div class="msg-${uuid}">已成功複製</div>
                ${preStyleSheet}
            </div>
        `

        return this._zipcodeText(copyCodeButtonHTML);
    }

    // ------------------------------
    // _getCodeClickText
    // ------------------------------
    _getCodeClickText(uuid) {

        let onclick = `
            event.preventDefault();
            event.stopImmediatePropagation();

            let textarea = document.querySelector('textarea[uuid="${uuid}"]');

            if(textarea && textarea.select) {
                textarea.select();
                document.execCommand("copy");

                if(this.copyMessageTimeout) {
                    clearTimeout(this.copyMessageTimeout);
                }

                let msg = document.getElementsByClassName('msg-${uuid}');

                if(msg && msg.length === 1) {
                    msg[0].style.opacity = 1;
                    msg[0].style.visibility = 'visible';

                    this.copyMessageTimeout = setTimeout(function() {
                        msg[0].style.opacity = 0;
                        msg[0].style.visibility = 'hidden';
                    }, 1000);
                }
            }
        `;

        return this._zipcodeText(onclick);
    }

    // ------------------------------
    // _getCodeMouseEnterText
    // ------------------------------
    _getCodeMouseEnterText(uuid) {

        let onmouseenter = `
            event.preventDefault();
            event.stopImmediatePropagation();

            let button = document.getElementsByClassName('button-${uuid}');

            if(button && button.length === 1) {
                button[0].style.opacity = 1;
                button[0].style.visibility = 'visible';
            }
        `;

        return this._zipcodeText(onmouseenter);
    }

    // ------------------------------
    // _getCodeMouseLevelText
    // ------------------------------
    _getCodeMouseLevelText(uuid) {

        let onmouseleave = `
            event.preventDefault();
            event.stopImmediatePropagation();

            let button = document.getElementsByClassName('button-${uuid}');

            if(button && button.length === 1) {
                button[0].style.opacity = 0;
                button[0].style.visibility = 'hidden';
            }
        `;

        return this._zipcodeText(onmouseleave);
    }

    // ------------------------------
    // _getImageReaderText
    // ------------------------------
    _getImageReaderText() {

        let load = `
            let reader = new Image();

            reader.onload = function() {
                let window_w = window.innerWidth;
                let window_h = window.innerHeight;    	
                let max_width = window_w - 20;
                let max_height = window_h - 20;
                let width = reader.naturalWidth;
                let height = reader.naturalHeight;
                let scale_w = max_width / width;
                let scale_h = max_height / height;

                let top = 0;
                let left = 0;
                if(scale_w < 1 || scale_h < 1) {
                    if(scale_w < scale_h) {
                        width = max_width;
                        height = height * scale_w;
                    } else {
                        height = max_height;
                        width = width * scale_h;
                    }
                } 

                left = (window_w - width) / 2;
                top = (window_h - height) / 2;

                image[0].style.left = left + 'px';
                image[0].style.top = top + 'px';
                image[0].style.width = width + 'px';
                image[0].style.height = height + 'px';
            };

            reader.onerror = function() {
                error[0].style.display = 'block';
            };
        `;

        return load;
    }

    // ------------------------------
    // _getImageModalText
    // ------------------------------
    _getImageModalText() {
        
        let style = `
            <style type="text/css">
                @keyframes showPreviewImagePlayer {
                    0% {
                        opacity: 0;
                    }
                    100% {
                        opacity: 1;
                    }
                }

                @keyframes hidePreviewImagePlayer {
                    0% {
                        opacity: 1;
                    }
                    100% {
                        opacity: 0;
                    }
                }

                #cupoynoteeditor-preview-image-player {
                    display: none;
                    position: fixed;
                    top: 0px;
                    left: 0px;
                    right: 0px;
                    bottom: 0px;
                    visibility: visible;
                    transform: translateZ(0px);
                    z-index: 99999999999;
                    transition: visibility 300ms ease 0s, z-index 0s ease 300ms;
                }

                #cupoynoteeditor-preview-image-player.show {
                    display: block;
                }

                #cupoynoteeditor-preview-image-player .preview-image-player-overlay {
                    position: fixed;
                    top: 0px;
                    left: 0px;
                    right: 0px;
                    bottom: 0px;
                    background-color: rgba(0, 0, 0, 0.8);
                    visibility: visible;
                    transform: translateZ(0px);
                    cursor: pointer;
                    /** animation: hidePreviewImagePlayer 0.3s ease-out 0s 1 normal none running; */
                }

                #cupoynoteeditor-preview-image-player.show .preview-image-player-overlay {
                    animation: showPreviewImagePlayer 0.3s ease-out 0s 1 normal none running;
                }

                #cupoynoteeditor-preview-image-player .preview-image-player-close {
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: 80px;
                    height: 80px;
                    background-color: transparent;
                    color: #FFF;
                    font-size: 24px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    user-select: none;
                }

                #cupoynoteeditor-preview-image-player .preview-image-player-close:before {
                    content: '';
                    display: block;
                    width: 8px;
                    height: 8px;
                    border-top: 2px solid #ddd;
                    border-right: 2px solid #ddd;
                    transform: rotate(45deg);
                }

                #cupoynoteeditor-preview-image-player .preview-image-player-close:after {
                    content: '';
                    display: block;
                    width: 8px;
                    height: 8px;
                    border-left: 2px solid #ddd;
                    border-bottom: 2px solid #ddd;
                    transform: rotate(45deg);
                }

                #cupoynoteeditor-preview-image-player .preview-image-player-image {
                    position: absolute;
                    transform: translateZ(0);	
                    background-size: cover;
                    background-repeat: no-repeat;
                    background-position: center center;
                    transition: all 300ms cubic-bezier(0.000, 0.000, 0.580, 1.000);
                    transition-timing-function: cubic-bezier(0.000, 0.000, 0.580, 1.000);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                #cupoynoteeditor-preview-image-player .preview-image-player-error-state {
                    display: none;
                }

                #cupoynoteeditor-preview-image-player .preview-image-player-error-content {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-color: rgba(0, 0, 0, 0.2);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 0 20px;
                    pointer-events: none;
                }

                #cupoynoteeditor-preview-image-player .preview-image-player-error-title {
                    font-size: 18px;
                    color: #FFF;
                    margin: 0;
                }

                #cupoynoteeditor-preview-image-player .preview-image-player-prev {
                    position: absolute;
                    top: 50%;
                    left: 0px;
                    width: 75px;
                    height: 300px;
                    border-radius: 0px 8px 8px 0px;
                    color: #fff;
                    font-size: 28px;
                    background-color: rgba(200, 200, 200, 0.1);
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transform: translateY(-50%);
                }

                #cupoynoteeditor-preview-image-player .preview-image-player-prev:before {
                    content: '';
                    display: block;
                    width: 8px;
                    height: 8px;
                    border-left: 2px solid #ddd;
                    border-bottom: 2px solid #ddd;
                    transform: rotate(45deg);
                }

                #cupoynoteeditor-preview-image-player .preview-image-player-next {
                    position: absolute;
                    top: 50%;
                    right: 0px;
                    width: 75px;
                    height: 300px;
                    border-radius: 0px 8px 8px 0px;
                    color: #fff;
                    font-size: 28px;
                    background-color: rgba(200, 200, 200, 0.1);
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transform: translateY(-50%);
                }

                #cupoynoteeditor-preview-image-player .preview-image-player-next:before {
                    content: '';
                    display: block;
                    width: 8px;
                    height: 8px;
                    border-top: 2px solid #ddd;
                    border-right: 2px solid #ddd;
                    transform: rotate(45deg);
                }
            </style>
        `;

        let html = `
            ${style}
            <div id="cupoynoteeditor-preview-image-player">
                <div class="preview-image-player-overlay"></div>
                <div class="preview-image-player-close"></div>
                <div class="preview-image-player-image"></div>
                <div class="preview-image-player-prev"></div>
                <div class="preview-image-player-next"></div>
                <div class="preview-image-player-error-state">
                    <div class="preview-image-player-error-content">
                        <div class="preview-image-player-error-title">無法順利載入圖片</div>
                    </div>
                </div>
            </div>
        `;

        let modal = document.createElement('div');
        modal.innerHTML = html;

        let selectResult;

        let closeImagePlayer = `
            let modal = document.getElementById('cupoynoteeditor-preview-image-player');
            modal.dataset['images'] = undefined;
            modal.style.display = 'none';
        `;

        let onImageClick = `
            let modal = document.getElementById('cupoynoteeditor-preview-image-player');
            let imagesText = modal.dataset['images'];
            let images = imagesText.split(',');
            let index = modal.dataset['imageindex'];

            index = isNaN(index) ? 0 : Number(index);

            let nextIndex = index + 1;

            if(nextIndex >= images.length) {
                modal.dataset['images'] = undefined;
                modal.style.display = 'none';
            } else {
                let nextImage = images[nextIndex];
                modal.dataset['imageindex'] = nextIndex;

                let image = modal.getElementsByClassName('preview-image-player-image');

                image[0].style.backgroundImage = "url('" + nextImage + "')";

                let error = modal.getElementsByClassName('preview-image-player-error-state');

                error[0].style.display = '';

                let prev = modal.getElementsByClassName('preview-image-player-prev');
                let next = modal.getElementsByClassName('preview-image-player-next');
                let hasPrev = true;
                let hasNext = nextIndex + 1 < images.length;

                if(hasPrev) {
                    prev[0].style.display = '';
                } else {
                    prev[0].style.display = 'none';
                }

                if(hasNext) {
                    next[0].style.display = '';
                } else {
                    next[0].style.display = 'none';
                }

                ${this._getImageReaderText()}

                reader.src = nextImage;
            }
        `;

        let onPrevClick = `
            let modal = document.getElementById('cupoynoteeditor-preview-image-player');
            let imagesText = modal.dataset['images'];
            let images = imagesText.split(',');
            let index = modal.dataset['imageindex'];

            index = isNaN(index) ? 0 : Number(index);

            let prevIndex = index - 1;

            if(prevIndex < 0) {
                modal.dataset['images'] = undefined;
                modal.style.display = 'none';
            } else {
                let prevImage = images[prevIndex];
                modal.dataset['imageindex'] = prevIndex;

                let image = modal.getElementsByClassName('preview-image-player-image');

                image[0].style.backgroundImage = "url('" + prevImage + "')";

                let error = modal.getElementsByClassName('preview-image-player-error-state');

                error[0].style.display = '';

                let prev = modal.getElementsByClassName('preview-image-player-prev');
                let next = modal.getElementsByClassName('preview-image-player-next');
                let hasPrev = prevIndex > 0;
                let hasNext = prevIndex + 1 < images.length;

                if(hasPrev) {
                    prev[0].style.display = '';
                } else {
                    prev[0].style.display = 'none';
                }

                if(hasNext) {
                    next[0].style.display = '';
                } else {
                    next[0].style.display = 'none';
                }

                ${this._getImageReaderText()}

                reader.src = prevImage;
            }
        `;

        let onNextClick = `
            let modal = document.getElementById('cupoynoteeditor-preview-image-player');
            let imagesText = modal.dataset['images'];
            let images = imagesText.split(',');
            let index = modal.dataset['imageindex'];

            index = isNaN(index) ? 0 : Number(index);

            let nextIndex = index + 1;

            if(nextIndex >= images.length) {
                modal.dataset['images'] = undefined;
                modal.style.display = 'none';
            } else {
                let nextImage = images[nextIndex];
                modal.dataset['imageindex'] = nextIndex;

                let image = modal.getElementsByClassName('preview-image-player-image');

                image[0].style.backgroundImage = "url('" + nextImage + "')";

                let error = modal.getElementsByClassName('preview-image-player-error-state');

                error[0].style.display = '';

                let prev = modal.getElementsByClassName('preview-image-player-prev');
                let next = modal.getElementsByClassName('preview-image-player-next');
                let hasPrev = nextIndex > 0;
                let hasNext = nextIndex + 1 < images.length;

                if(hasPrev) {
                    prev[0].style.display = '';
                } else {
                    prev[0].style.display = 'none';
                }

                if(hasNext) {
                    next[0].style.display = '';
                } else {
                    next[0].style.display = 'none';
                }

                ${this._getImageReaderText()}

                reader.src = nextImage;
            }
        `;

        selectResult = modal.getElementsByClassName('preview-image-player-overlay');
        selectResult[0].setAttribute('onclick', closeImagePlayer);
        selectResult = modal.getElementsByClassName('preview-image-player-close');
        selectResult[0].setAttribute('onclick', closeImagePlayer);
        selectResult = modal.getElementsByClassName('preview-image-player-image');
        selectResult[0].setAttribute('onclick', onImageClick);
        selectResult = modal.getElementsByClassName('preview-image-player-prev');
        selectResult[0].setAttribute('onclick', onPrevClick);
        selectResult = modal.getElementsByClassName('preview-image-player-next');
        selectResult[0].setAttribute('onclick', onNextClick);
        
        return this._zipcodeText(modal.innerHTML);
    }

    // ------------------------------
    // _getImagesClickText
    // ------------------------------
    _getImagesClickText(imagesText, index, isAlbum) {

        let onclick = ``;

        index = isNaN(index) ? 0 : Number(index);

        if(isAlbum && this.options.handlePlayAlbumBlock) {
            onclick = `
                this.dispatchEvent(new CustomEvent('playAlbumBlock', {
                    bubbles: true,
                    cancelable: true,
                    detail: {
                        allImageSrc: '${imagesText}',
                        index: '${index}',
                        mouseEvent: event,
                    },
                }))
            `;
        } else if(!isAlbum && this.options.handlePlayImageBlock) {
            onclick = `
                this.dispatchEvent(new CustomEvent('playImageBlock', {
                    bubbles: true,
                    cancelable: true,
                    detail: {
                        imageSrc: '${imagesText}',
                        mouseEvent: event,
                    },
                }))
            `;
        } else {
            let images = imagesText.split(',');
            let image = images[index];
            let cursorText = images.length > 1 ? 'pointer' : 'zoom-out';
            let hasPrev = index > 0;
            let hasNext = index + 1 < images.length;

            onclick = `
                event.preventDefault();
                event.stopImmediatePropagation();

                let modal = document.getElementById('cupoynoteeditor-preview-image-player');
                modal.dataset['images'] = '${imagesText}';
                modal.dataset['imageindex'] = ${index};

                let image = modal.getElementsByClassName('preview-image-player-image');
                image[0].style.left = '';
                image[0].style.top = '';
                image[0].style.width = '';
                image[0].style.height = '';
                image[0].style.backgroundImage = "url('${image}')";
                image[0].style.cursor = '${cursorText}';

                let error = modal.getElementsByClassName('preview-image-player-error-state');

                error[0].style.display = '';

                let prev = modal.getElementsByClassName('preview-image-player-prev');
                let next = modal.getElementsByClassName('preview-image-player-next');

                ${hasPrev ? "prev[0].style.display = '';" : "prev[0].style.display = 'none';"}
                ${hasNext ? "next[0].style.display = '';" : "next[0].style.display = 'none';"}

                ${this._getImageReaderText()}

                reader.src = '${image}';
                modal.style.display = 'block';
            `;
        }

        return this._zipcodeText(onclick);
    }

    // ------------------------------
    // _convertToCupoyPreviewHtml
    // ------------------------------
    _convertToCupoyPreviewHtml() {
        
        if(!this.element) {
            return;
        }

        let self = this;

        let styleText = this._getStyleText();
        
        // 補上預設樣式
        this.element.insertAdjacentHTML('afterbegin' ,styleText)

        let imageModal = document.getElementById('cupoynoteeditor-preview-image-player');

        if(!imageModal) {
            let imageModalText = this._getImageModalText();
            document.body.insertAdjacentHTML('beforeend' ,imageModalText)
        }

        // 對內部item處理
        let selectResult = undefined;

        // 圖片 widget
        selectResult = this.element.querySelectorAll('img[widget-image]') || [];
        Array.prototype.forEach.call(selectResult, function(child) {
            let uuid = self._generateUid();
            let imageSrc = child.getAttribute('src');
            let onclick = self._getImagesClickText(imageSrc, 0);
            child.style.cursor = 'pointer';

            child.setAttribute('uuid', uuid);
            child.setAttribute('onclick', onclick);
        });

        // 影片 widget
        selectResult = this.element.querySelectorAll('img[widget-video]') || [];
        Array.prototype.forEach.call(selectResult, function(child) {
            let videourl = child.getAttribute('videourl');
            let videoid = videourl.split('v=')[1];
            let src = 'https://www.youtube.com/embed/' + videoid + '?rel=0&showinfo=0&enablejsapi=1&version=3&playerapiid=ytplayer';

            let iframe = document.createElement('iframe');
            iframe.className = 'iframe-video';
            iframe.setAttribute('src', src);
            iframe.setAttribute('frameborder', 0);
            iframe.setAttribute('allowfullscreen', '');

            child.parentNode.insertBefore(iframe, child);
            child.parentNode.removeChild(child);
        });

        // 內文 widget
        selectResult = this.element.querySelectorAll('a[widget-textblock]') || [];
        Array.prototype.forEach.call(selectResult, function(child) {
            let uuid = self._generateUid();
            let attachurl = child.getAttribute('data-attachurl');
            let onclick = self.getTextblockClickText(attachurl, uuid);
            
            child.setAttribute('uuid', uuid);
            child.setAttribute('onclick', onclick);
        });

        // 相簿 widget
        selectResult = this.element.querySelectorAll('div[widget-album]') || [];
        Array.prototype.forEach.call(selectResult, function(child) {
            let uuid = self._generateUid();
            let index = child.getAttribute('data-index');
            let allImageSrc = undefined;
            let current = child;

            while(current !== null) {
                allImageSrc = current.getAttribute('data-attachurl');

                if(!!allImageSrc) {
                    break;
                }

                current = current.parentNode;
            }

            let onclick = self._getImagesClickText(allImageSrc, index, true);

            child.setAttribute('uuid', uuid);
            child.setAttribute('onclick', onclick);
        });

        // hashtag
        selectResult = this.element.querySelectorAll('span[hashtag]') || [];
        Array.prototype.forEach.call(selectResult, function(child) {
            let uuid = self._generateUid();
            let hashtag = child.getAttribute('hashtag');
            let onclick = self._getHashtagClickText(hashtag, uuid);
            
            child.setAttribute('uuid', uuid);
            child.setAttribute('onclick', onclick);
        });

        // 註解
        selectResult = this.element.querySelectorAll('span[data-annotation]') || [];
        Array.prototype.forEach.call(selectResult, function(child) {
            let uuid = self._generateUid();
            let annotation = child.getAttribute('data-annotation');
            let annotationhtml = self._getAnnotationDivHTML(annotation, uuid);
            let onclick = self._getAnnotationClickText(uuid);

            child.insertAdjacentHTML('beforeend', annotationhtml);
            child.setAttribute('uuid', uuid);
            child.setAttribute('onclick', onclick);

            // 將annotation所在的p改用abbr包覆
            let abbr = document.createElement('abbr');
            abbr.innerHTML = child.outerHTML;

            child.parentNode.insertBefore(abbr, child);
            child.parentNode.removeChild(child);
        });

        // 程式碼
        selectResult = this.element.querySelectorAll('div[widget-code-block]') || [];
        Array.prototype.forEach.call(selectResult, function(child) {
            let uuid = self._generateUid();
            let copyCodeButtonHTML = self._getCopyCodeButtonHtml(uuid);
            let textarea = child.querySelector('textarea');

            if(textarea) {
                let onmouseenter = self._getCodeMouseEnterText(uuid);
                let onmouseleave = self._getCodeMouseLevelText(uuid);

                textarea.setAttribute('uuid', uuid);
                child.setAttribute('onmouseenter', onmouseenter);
                child.setAttribute('onmouseleave', onmouseleave);
                child.insertAdjacentHTML('beforeend', copyCodeButtonHTML);

                let button = child.getElementsByClassName('button-' + uuid);

                if(button && button.length === 1) {
                    let onclick = self._getCodeClickText(uuid);
                    button[0].setAttribute('onclick', onclick);
                }
            }
        });
    }

    // ------------------------------
    // [PUBLIC] getResultHtml
    // ------------------------------
    getResult() {

        return this.element;
    }
}


// bundler 契約：cupoy-draft/cupoy-draft-mobile-ng-module.js 以裸識別字
// new CupoyNoteHtmlParser(...) 讀這個 class。mobile 把本檔列在 manifest scripts 內
// （admin 那一側是 $ocLazyLoad 在 runtime 抓 classic script），因此 bundle 之後
// 兩支檔案分屬不同 module scope，裸識別字再也對不上。
window.CupoyNoteHtmlParser = CupoyNoteHtmlParser;
